import { createTheme } from "@mui/material/styles";
import { color, font, radius, shadow, type } from "./tokens";

/*
 * Cosmic-dark MUI theme. Every value derives from the single token source
 * (src/theme/tokens.ts) so MUI components, Tailwind utilities and the dial
 * layer all share one visual language. Do not hardcode colours here.
 */
export const theme = createTheme({
	palette: {
		mode: "dark",
		primary: {
			main: color.violet,
			dark: color.violet700,
			light: color.violet300,
			contrastText: color.white,
		},
		secondary: { main: color.gold, contrastText: color.onGold },
		error: { main: color.halfsum },
		success: { main: color.success },
		background: { default: color.bg, paper: color.surface },
		text: { primary: color.text, secondary: color.textMuted },
		divider: color.border,
	},
	shape: { borderRadius: parseInt(radius.md, 10) },
	typography: {
		fontFamily: font.sans,
		h1: { fontFamily: font.display, fontWeight: 600 },
		h2: { fontFamily: font.display, fontWeight: 600 },
		h3: { fontFamily: font.display, fontWeight: 600 },
		h4: { fontFamily: font.display, fontWeight: 600 },
		button: { textTransform: "none", fontWeight: 600 },
	},
	components: {
		MuiPaper: {
			styleOverrides: {
				root: { backgroundImage: "none" },
			},
		},
		MuiButton: {
			defaultProps: { disableElevation: true },
			styleOverrides: {
				root: { borderRadius: parseInt(radius.md, 10) },
				containedPrimary: { boxShadow: shadow.glow },
			},
		},
		MuiDrawer: {
			styleOverrides: {
				paper: {
					backgroundColor: color.surface,
					backgroundImage: "none",
					borderColor: color.border,
				},
			},
		},
		MuiDialog: {
			styleOverrides: {
				paper: { backgroundColor: color.surface, backgroundImage: "none" },
			},
		},
		MuiTab: {
			styleOverrides: { root: { textTransform: "none", fontWeight: 500 } },
		},
		MuiListSubheader: {
			styleOverrides: {
				root: {
					fontFamily: font.display,
					fontSize: type.size.xl,
					fontWeight: type.weight.semibold,
					color: color.text,
					backgroundColor: "transparent",
					lineHeight: 2,
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					backgroundColor: color.surface2,
					border: `1px solid ${color.border}`,
				},
			},
		},
	},
});

export default theme;
